import { SET_RECORDING_ENABLED, SET_RECORD_CLASS } from "./actionType";
import { RECORDING_TYPE } from "./constants";

export function setRecordingEnabled(recordType, enabled) {
    return async (dispatch, getState) => {
        if (recordType === RECORDING_TYPE.SERVER && enabled) {
            // check API
            const { complete, message } = await APP.API.addRecordResource();
            
            if (complete) {
                dispatch({
                    type: SET_RECORDING_ENABLED,
                    recordType,
                    enabled, 
                    option: message
                });
            } 

            return;
        }

        dispatch({
            type: SET_RECORDING_ENABLED,
            recordType,
            enabled,
            option: null
        });
    }
}

export function setReocrdClass(recordType, recordClass) {
    return {
        type: SET_RECORD_CLASS,
        recordType,
        recordClass
    }
}